export const CONFIRM_DIALOG_DELETE = 'この操作は取り消しできません。<br/>本当に削除を実行しますか？';
